import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from './services/analytics.service'
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { LeadService } from "./services/lead.service";
import { QuestionnaireService } from "./services/questionnaire.service";

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	closeResult: string;
	title = 'app';
	private route$: Subscription;
	appConfig = environment;

	constructor(
		translate: TranslateService,
		private analyticsService: AnalyticsService,
		private activeRoute: ActivatedRoute,
		private leadService: LeadService,
		private router: Router,
		private questionnaireService: QuestionnaireService
	) {
		translate.setDefaultLang('he');
		translate.use('he');
		
		this.setGA();


		// if(/[.]*dev/.test(window.location.search)){//has dev in querystring
		// 	this.setDev();
		// }
		this.questionnaireService.reset("1");
	}

	ngOnInit() {
	}

	setGA() {
		//this.analyticsService.trackView();
		this.route$ = this.activeRoute.params.subscribe(params => {

		});

		this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: any) => {
			// see also 
			//console.log(val instanceof NavigationEnd) 
			//let path = event.url.split("/");
			//this.analyticsService.trackView(path[1],path[2],path[3]);	
			this.analyticsService.trackView(event.url);
			//console.log(">>> router.events:",val);
		});
	}

	sendFormTest() { //TODO: remove
		this.leadService.submitMashForm().subscribe(
			data => {
				console.log("send lead sucseed");
			});
	}

	setDev(){
		document.body.className="dev"
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts